<template>
  <CustomTitleBar title="周边市集" />
  <div class="page-content">
    <el-empty v-if="goodsList.length === 0" description="暂无数据" :image="require('@/assets/images/empty.png')" />
    <van-row v-else gutter="12">
      <van-col v-for="item in goodsList" :key="item.id" span="12" @click="goDetail(item)">
        <div class="custom-card">
          <img class="card-image" v-if="item.picture" :src="baseUrl + item.picture" alt="商品图片" />
          <img class="card-image" v-else src="@/assets/images/no-pic.png" alt="商品图片" />
          <div class="card-content">
            <span class="card-title">{{ item.detailTitle }}</span>
            <span class="card-desc">{{ item.subTitle }} - {{ item.price }}元</span>
            <div class="card-price">
              <span class="price-text">￥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted, ref } from "vue";
import { getNewGoodsList } from "@/api/shop";
import { showToast } from "vant";
import { useRouter } from 'vue-router';

const router = useRouter();

const baseUrl = process.env.VUE_APP_IMG_BASE_URL;

const goodsList = ref<any[]>([]);

const getList = () => {
  getNewGoodsList({
    current: 1,
    size: 99999
  }).then((res) => {
    if (res.code === 200) {
      goodsList.value = res.data;
    } else {
      goodsList.value = [];
      showToast(res.msg);
    }
  });
};

onMounted(() => {
  getList();
});

const goDetail = (item: any) => {
  router.push({ path: '/ShopDetail', query: { item: JSON.stringify(item) } });
};
</script>

<style lang="scss" scoped>
.page-content {
  padding: 56px 16px 16px;
  box-sizing: border-box;
}

.custom-card {
  margin-bottom: 12px;
  height: 286px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-image {
  width: 100%;
  height: 190px;
  object-fit: cover;
}

.card-content {
  margin-top: 8px;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
}

.card-title {
  margin-bottom: 8px;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-desc {
  font-size: 12px;
  letter-spacing: 1px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.3;
  min-height: 2.6em;
}

.card-price {
  text-align: right;
  color: #FA5151;
  font-weight: 500;
}
</style>